import { Box, Typography, Table, TableBody, TableCell, TableRow, TableHead } from "@mui/material";

const hexToColorMap = {
  "#51653D": "Light Green",
  "#545D44": "Forest Green",
  "#3F4134": "Dark Green",
  "#7E6F5C": "Beige",
  "#40322E": "Brown",
  "#653A39": "Red",
  "#BBA87B": "Sandstone",
  "#59403F": "Maroon",
  "#3F3C5E": "Tournament Purple",
  "#6F6F76": "Gray",
  "#303C59": "Blue",
  "#4E6383": "Light Blue",
  "#979797": "Dove Gray",
  "#89B2CE": "Ice Blue",
  "#E2C15F": "Yellow",
  "#CD6543": "Orange",
  "#B54033": "Bright Red",
  "#111111": "Black"
};

const ColorDisplay = ({ colors }) => {
  if (!colors) return null;
  
  const colorObj = typeof colors === 'string' ? JSON.parse(colors) : colors;

  return (
    <Table size="large" >
      <TableHead>
        <TableRow>
          <TableCell sx={{ fontWeight: 'bold' }}>Area</TableCell>
          <TableCell sx={{ fontWeight: 'bold' }}>Color Name</TableCell>
          <TableCell sx={{ fontWeight: 'bold' }}>Sample</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {Object.entries(colorObj).map(([key, value]) => (
          <TableRow key={key}>
            <TableCell>
              <Typography variant="body2">{key}</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body2">
                {hexToColorMap[value] || value}
              </Typography>
            </TableCell>
            <TableCell>
              <Box 
                sx={{ 
                  width: 24, 
                  height: 24, 
                  borderRadius: '4px', 
                  border: '1px solid #ddd',
                  backgroundColor: value 
                }} 
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default ColorDisplay;